import * as VueRouter from "vue-router";
// @ts-ignore
import store from "../store/index.js";
import routes from "./routes";
import { isUserLoggedIn, checkAndRedirect } from "@/utils/auth";
import { showToast } from "@/utils/toast";

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory("/"),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {top: 0}
    }
  },
})

// 【方案A统一】需要登录验证的路由路径
const authRequiredPaths = [
  '/training',
  '/training-management',
  '/training/player',
  '/contract/signing',
  '/contract/signing-success',
  '/p-personal-center',
  '/user/profile',
  '/user/change-password',
  '/user/messages',
  '/user/application-progress',
  '/user/settings',
  '/p-home',
  '/home',
  '/registration',
]

// 【方案A统一】功能路径映射到功能类型
const featurePathMap: Record<string, 'registration' | 'training' | 'signing' | 'personal'> = {
  '/registration': 'registration',
  '/training': 'training',
  '/training-management': 'training',
  '/training/player': 'training',
  '/contract/signing': 'signing',
  '/contract/signing-success': 'signing',
  '/p-personal-center': 'personal',
  '/user/profile': 'personal',
  '/user/change-password': 'personal',
  '/user/messages': 'personal',
  '/user/application-progress': 'personal',
  '/user/settings': 'personal',
}

// 检查路径是否需要登录
const requiresAuth = (path: string): boolean => {
  return authRequiredPaths.some(authPath => 
    path === authPath || path.startsWith(authPath + '/')
  )
}

// 获取路径对应的功能类型
const getFeatureType = (path: string): 'registration' | 'training' | 'signing' | 'personal' | null => {
  for (const [featurePath, featureType] of Object.entries(featurePathMap)) {
    if (path === featurePath || path.startsWith(featurePath + '/')) {
      return featureType
    }
  }
  return null
}

router.beforeEach((to, from) => {
  // 【方案A统一】登录验证守卫
  if (requiresAuth(to.path)) {
    if (!isUserLoggedIn()) {
      showToast('请先登录')
      // 保存目标路径，登录后可跳回
      sessionStorage.setItem('redirectAfterLogin', to.fullPath)
      return { path: '/Auth1', query: { type: 'login' } }
    }
  }

  const noAnimation = ['/', '/home', '/me', '/attention', '/message', '/publish', '/home/live']
  if (noAnimation.includes(from.path) && noAnimation.includes(to.path)) {
    return true
  }
  
  const toDepth = routes.findIndex(v => v.path === to.path)
  const fromDepth = routes.findIndex(v => v.path === from.path)
  
  if (toDepth > fromDepth) {
    if (to.matched?.[0]?.components?.default?.name) {
      const toComponentName = to.matched[0].components.default.name
      store.commit('updateExcludeRoutes', {type: 'remove', value: toComponentName})
    }
  } else {
    if (from.matched?.[0]?.components?.default?.name) {
      const fromComponentName = from.matched[0].components.default.name
      store.commit('updateExcludeRoutes', {type: 'add', value: fromComponentName})
    }
  }
  
  return true
})

export default router 